/**
 * @class
 * Collection to handle attribute templates/values for attribute profiles
 * https://kb.netx.net/display/DEV/Attribute+Profiles+for+Folders
 */

import Base from '../collections/attributes';
import Model from '../models/attributeProfileAttribute';

export default class AttributeProfileAttributes extends Base {
	/** @override */
	constructor(models, opts = {}) {
		opts.model = opts.model || Model;

		super(models, opts);

		this.comparator = null;
	}

	/** @type {string} */
	static get __name__() {
		return 'AttributeProfileAttributes';
	}
}
